import { Modal, Button } from 'react-bootstrap';
import './ModalAreYouSure.css';

const ModalAreYouSure = ({ parentState, backCallerHandleCancelModalAreYouSure }) => {
    // console.log(parentState.helper.modalAYS);
    return (
        <>
            <Modal className="modal-lg" show={parentState.helper.modalAYS.visible}
                onHide={() => backCallerHandleCancelModalAreYouSure()}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{parentState.helper.modalAYS.header}</Modal.Title>
                </Modal.Header>

                <Modal.Body>{parentState.helper.modalAYS.body}</Modal.Body>

                <Modal.Footer>
                    {(parentState.helper.modalAYS.footer_cancel.length > 0) && (
                        <>
                            <Button variant="secondary" onClick={() => backCallerHandleCancelModalAreYouSure()}>
                                {parentState.helper.modalAYS.footer_cancel}
                            </Button>
                        </>
                    )}

                    <Button variant="primary" onClick={parentState.helper.modalAYS.method_confirm}>
                        {parentState.helper.modalAYS.footer_confirm}
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalAreYouSure;